export default "__VITE_ASSET__8471d402__"